"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionsControllerListPlansV1200Response = instanceOfSubscriptionsControllerListPlansV1200Response;
exports.SubscriptionsControllerListPlansV1200ResponseFromJSON = SubscriptionsControllerListPlansV1200ResponseFromJSON;
exports.SubscriptionsControllerListPlansV1200ResponseFromJSONTyped = SubscriptionsControllerListPlansV1200ResponseFromJSONTyped;
exports.SubscriptionsControllerListPlansV1200ResponseToJSON = SubscriptionsControllerListPlansV1200ResponseToJSON;
exports.SubscriptionsControllerListPlansV1200ResponseToJSONTyped = SubscriptionsControllerListPlansV1200ResponseToJSONTyped;
var PlanCatalogResponseDto_1 = require("./PlanCatalogResponseDto");
/**
 * Check if a given object implements the SubscriptionsControllerListPlansV1200Response interface.
 */
function instanceOfSubscriptionsControllerListPlansV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SubscriptionsControllerListPlansV1200ResponseFromJSON(json) {
    return SubscriptionsControllerListPlansV1200ResponseFromJSONTyped(json, false);
}
function SubscriptionsControllerListPlansV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, PlanCatalogResponseDto_1.PlanCatalogResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function SubscriptionsControllerListPlansV1200ResponseToJSON(json) {
    return SubscriptionsControllerListPlansV1200ResponseToJSONTyped(json, false);
}
function SubscriptionsControllerListPlansV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, PlanCatalogResponseDto_1.PlanCatalogResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
